module.exports = "https://community-app-cdn.topcoder.com/static-assets/images/a91774102901ebdd195f412dd79ac53c.png";